import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import {
    selectCmsFromBootstrap,
    selectConfigFromBootstrap,
    selectExperimentsFromBootstrap,
    selectFeatureBehaviorFromBootstrap,
    selectGeoFromBootstrap,
    selectLocaleFromBootstrap,
    selectPageTypeIdFromBootstrap,
} from 'store/slice/bootstrap';
import { selectTextForTextSearch } from 'store/slice/home';
import { BootstrapConfig, CmsValue, Geo } from 'core/type/BootstrapConfig.types';
import { SuggestionResult } from 'core/type/SuggestionResult.types';
import { ActivityCardProps } from 'core/type/ActivityCard.types';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { isB } from 'core/window/bootstrapConfig';
import { FunnelExperimentId } from 'core/type/ExperimentId';

interface OwnProps {
    query: string;
    setSearchText: React.Dispatch<React.SetStateAction<string>>;
    setSelectedResult: (selected: SuggestionResult) => void;
    onClearSearch?: () => void;
    width?: string;
    popularActivities?: ActivityCardProps[];
    dataElementName?: string;
    isHomeSearchBox: boolean; // Will be false except homepage
    isNewHomePageEnabled?: boolean;
    placeholderText: string;
    onKeywordResultSelect?: (keyword: string, geo: Geo) => void;
    onGlobalKeywordResultSelect?: (keyword: string) => void;
    isDisabledGlobalKeywordSearch?: boolean;
}

interface StateProps {
    config: BootstrapConfig;
    cms: CmsValue;
    locale: string;
    searchText: string;
    screenSize: ScreenSize;
    isSearchBoxFeatureGroup: boolean;
    isOpenSearchOverlayOnLanding: boolean;
    suggestionResult?: SuggestionResult;
    pageTypeId: ActivitiesPageTypes;
    isGlobalKeywordSearch?: boolean;
    geo?: Geo;
    isModifyEnterKeyPressForSearchExpOn: boolean;
}

export type SearchBoxPopoverProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectCmsFromBootstrap,
    selectLocaleFromBootstrap,
    selectGeoFromBootstrap,
    selectTextForTextSearch,
    selectFeatureBehaviorFromBootstrap,
    selectScreenSize,
    selectPageTypeIdFromBootstrap,
    selectExperimentsFromBootstrap,
    (config, cms, locale, geo, searchText, featureBehaviours, screenSize, pageTypeId, experiments): StateProps => {
        return {
            config,
            cms,
            locale,
            searchText,
            screenSize,
            pageTypeId,
            suggestionResult: geo,
            isSearchBoxFeatureGroup: featureBehaviours.SearchBoxFeatureGroup,
            isOpenSearchOverlayOnLanding: featureBehaviours.OpenSearchOverlayOnLanding,
            isGlobalKeywordSearch: featureBehaviours.GlobalKeywordSearch,
            geo,
            isModifyEnterKeyPressForSearchExpOn: featureBehaviours.GlobalKeywordSearch && isB(FunnelExperimentId.ACT_5328, experiments),
        };
    },
);
